import GoogleMap from '@PROJECT_ROOT/assets/mobile/js/shared/googleMap';
import loadGoogleMaps from '@PROJECT_ROOT/assets/mobile/js/infrastructure/loadGoogleMaps';

export default function loadMapTabContent(mapContainer, mapDataPromise) {
    if (mapContainer.hasChildNodes()) {
        return;
    }

    loadGoogleMaps().then((google) => {
        mapDataPromise.then((options) => GoogleMap(google, mapContainer, options));
    });
}
